import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  notFoundRoot: {
    display: 'flex',
    alignItems: 'center',
  },
  notFoundLabel: {
    marginRight: theme.spacing(0.5),
    width: '160px',
  },
  notFoundValue: {
    color: theme.palette.error.dark,
  },
  chipLabel: {
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  chipLabelOverride: {
    marginLeft: 0,
  },
  infoIcon: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  tooltipContentContainer: {
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  tooltipContentRow: {
    minWidth: 254,
    display: 'flex',
    justifyContent: 'space-between',
  },
  tooltipContentSecondText: {
    paddingLeft: theme.spacing(4),
  },
}));

export default useStyles;
